import { useContext, useEffect } from 'react'
import jsLogger from 'js-logger'
import ConnectionContext from 'shared/contexts/ConnectionContext'

const TEST_FILE_URL = '/testfile.bin'
const TEST_FILE_SIZE = 500000
const THRESHOLD = 5

interface NetworkSpeedCheckProps {
  onSpeedMeasured?: (speed: number) => void
}

const NetworkSpeedCheck = ({
  onSpeedMeasured
}: NetworkSpeedCheckProps) => {
  const { updateConnectionStatus } = useContext(ConnectionContext)

  useEffect(() => {
    const measureDownloadSpeed = async () => {
      try {
        await fetch(TEST_FILE_URL + '&warmup=1', {
          headers: { Origin: window.location.origin }
        })

        const results = await Promise.all(
          [1, 2, 3].map(async () => {
            const start = performance.now()
            const response = await fetch(`${TEST_FILE_URL}&t=${Date.now()}`, {
              headers: { Origin: window.location.origin },
              cache: 'no-store'
            })
            await response.blob()
            const duration = (performance.now() - start) / 1000
            return (TEST_FILE_SIZE * 8) / (duration * 1e6)
          })
        )

        const res = results.sort()[1]
        jsLogger.log('network test res:', res)

        const isNetworkSlow = res < THRESHOLD
        if (isNetworkSlow) {
          jsLogger.warn(`network test < ${THRESHOLD}`)
        }

        // Report to ConnectionContext: true = good connection, false = slow
        updateConnectionStatus('slowNet', !isNetworkSlow)

        if (onSpeedMeasured) {
          onSpeedMeasured(res)
        }
      } catch (err) {
        jsLogger.error('network test failed', err)
      }
    }
    measureDownloadSpeed()
  }, [onSpeedMeasured, updateConnectionStatus])

  // This component only reports network status to ConnectionContext - it doesn't render anything
  return null
}

export default NetworkSpeedCheck
